export const featureFlagNames = {
    IsSelfCheckInEnabled: 'isSelfCheckInEnabled',
    IsUnifiedCheckInEnabled: 'isUnifiedCheckInEnabled',
    IsOverrideStoreHours: 'isOverrideStoreHours',
    IsPreCheckinV2Enabled: 'isPreCheckinV2Enabled',
};
